import { createContext, useContext, useEffect, useState } from "react";

const STR = {
    en: {
        nav: {
            home: "Home", about: "About", products: "Products", services: "Services",
            solar: "Solar", cctv: "CCTV", contact: "Contact", call: "Call Now",
        },
        hero: {
            eyebrow: "Power · Solar · Security · Connectivity — Murshidabad",
            lines: [
                { text: "POWERING YOUR ", accent: "HOME." },
                { text: "PROTECTING YOUR ", accent: "WORLD." },
                { text: "CONNECTING YOUR ", accent: "LIFE." },
            ],
            sub: "Complete solutions for power backup, solar energy, CCTV security and broadband connectivity from Farakka Broadband.",
            call: "Call Now",
            explore: "Explore Products",
            chips: ["Power Backup", "Solar Solutions", "CCTV Security", "Broadband Connection"],
        },
        marquee: ["POWER BACKUP", "SOLAR ENERGY", "CCTV SECURITY", "BROADBAND", "INSTALLATION & SUPPORT", "HOME & BUSINESS"],
        products: {
            eyebrow: "Catalogue",
            heading: "OUR PRODUCTS",
            sub: "Smart solutions for power, energy, security and connectivity.",
            items: {
                "smarten-inverter": { name: "Smarten Inverter", description: "Reliable inverter solutions for dependable power backup at home and work.", cta: "Enquire Now", category: "Power Backup" },
                "inverter-battery": { name: "Inverter Battery", description: "Power backup battery solutions designed for reliable everyday use.", cta: "Enquire Now", category: "Power Backup" },
                "lithium-battery": { name: "Lithium Battery", description: "Modern battery technology for efficient and reliable energy storage.", cta: "Enquire Now", category: "Power Backup" },
                "solar-panels": { name: "Solar Panels", description: "Harness solar energy with modern solar panel solutions.", cta: "Get Solar Quote", category: "Solar" },
                "complete-solar-setup": { name: "Complete Solar Setup", description: "Complete solar solutions including panel setup and related installation requirements.", cta: "Get Solar Quote", category: "Solar" },
                "cctv-cameras": { name: "CCTV Cameras", description: "Security camera solutions for homes, shops, offices and other properties.", cta: "Enquire Now", category: "Security" },
                "broadband-connection": { name: "Broadband Connection", description: "Reliable broadband connectivity solutions for homes and businesses.", cta: "Get Connection", category: "Connectivity" },
                "ev-chargers": { name: "EV Chargers & E-Bikes", description: "Smarten EV chargers, lithium EV batteries and Cykal electric bikes — for scooters, rickshaws and cycles.", cta: "Enquire Now", category: "EV Charging" },
            },
            viewDetails: "View Details",
            downloadCatalogue: "Download Smarten Catalogue (PDF)",
            modal: { call: "Call", enquire: "Enquire About This" },
            details: {
                "smarten-inverter": {
                    groups: [
                        { title: "Home UPS — Pure Sine Wave", items: [
                            { name: "Bravo", note: "1050VA – 10000VA · 12V–120V" },
                            { name: "Bravo Eco", note: "875VA – 2050VA · up to 30% power saving" },
                            { name: "Nova", note: "1075VA – 3050VA · performance with style" },
                        ]},
                        { title: "Solar PCU", items: [
                            { name: "Helio", note: "MPPT · in-built lithium battery · 900–1500VA" },
                            { name: "Trendy / Superb", note: "MPPT · 1100VA – 20KVA" },
                            { name: "Boom", note: "Economical PWM solar PCU · 400–2050VA" },
                            { name: "Kranti+", note: "Battery-less solar PCU · 5–10KVA" },
                            { name: "Ultra", note: "MPPT hybrid solar PCU · 1–50KVA" },
                        ]},
                        { title: "On-Grid Solar Inverters", items: [
                            { name: "Star (Single Phase)", note: "1KW – 6KW · up to 97.8% efficiency" },
                            { name: "Star (Three Phase)", note: "5KW – 25KW · IP66" },
                        ]},
                        { title: "Solar Charge Controllers", items: [
                            { name: "Prime+", note: "MPPT · converts your inverter into a solar inverter" },
                            { name: "Savior", note: "PWM · up to 25A PV current" },
                        ]},
                    ],
                    note: "Authorised Smarten distributor — full range from the Smarten 2021–22 catalogue. Call for current models and pricing.",
                },
                "inverter-battery": {
                    models: [
                        { name: "Smarten Boom — Tubular & Tall Tubular", tag: "Worry not, let's boom!", features: ["40Ah – 180Ah · 12V", "Low Self Discharge", "Superior High Rate Discharge", "Long Cycle Life", "Level Indicator for Easy Maintenance"] },
                        { name: "Smarten Shine+ / Saver+ — Solar Tall Tubular", tag: "Durable & compatible in all ways!", features: ["170Ah – 350Ah · 12V", "Hi-Power Selenium Technology", "More Backup, More Reliability", "Ultra Low Maintenance", "Long Life"] },
                        { name: "Smarten Star Series ST 200C10", note: "Tall tubular battery" },
                        { name: "Exide Batteries", note: "For home and vehicles" },
                        { name: "Amaron Batteries", note: "Bike and four-wheeler batteries available" },
                    ],
                    note: "Ask us for the right capacity for your home or shop.",
                },
                "lithium-battery": {
                    models: [
                        { name: "INTU", tag: "12.8V 60Ah · 768Wh", features: ["LiFePO4", "Compatible with All Inverters", "5 Years Warranty"] },
                        { name: "INTU+ (HA550)", tag: "12.8V 90Ah · 1152Wh", features: ["LiFePO4", "Compact & Lightweight", "Fast Charging", "5 Years Warranty"] },
                        { name: "INTU X", tag: "12.8V 100Ah · 1280Wh", features: ["Higher Capacity", "Extended Backup", "Mixer Compatible", "5 Years Warranty"] },
                        { name: "INTU PRO", tag: "12.8V 150Ah · 25.6V 100Ah · up to 2560Wh", features: ["Maximum Performance", "Heavy Load Support", "10 Years Service Life"] },
                        { name: "INTU HOME PSW 1100", tag: "Inbuilt Lithium Inverter · 1100VA / 880W", features: ["Inbuilt 12.8V 100Ah Lithium (1280Wh)", "Pure Sine Wave", "Fast Charging at 20A", "Wall Mountable", "LCD Display", "5 Years Warranty"] },
                        { name: "INTU ZON4", tag: "Solar Hybrid Inverter · 4000W", features: ["MPPT Solar Charging up to 6500W", "Works With or Without Battery", "Built-in BMS + WiFi Monitoring", "Pure Sine Wave", "Slim Body"] },
                        { name: "Smarten ENERGia", tag: "Power with Intelligence", features: ["12.8V / 25.6V / 51.2V — 100Ah", "Bluetooth Connectivity*", "Extended Lifespan", "Low Self Discharge", "Long Life Cycle", "Active Balancing*", "Eco Friendly"] },
                    ],
                    brochures: [
                        { label: "INTU / INTU+ / INTU X / INTU PRO Range Brochure (PDF)", file: "/docs/INTU-PLUS-Brochure.pdf" },
                        { label: "INTU HOME PSW 1100 Brochure (PDF)", file: "/docs/INTU-HOME-PSW-1100-Brochure.pdf" },
                        { label: "INTU ZON4 Hybrid Inverter Brochure (PDF)", file: "/docs/INTU-ZON4-Hybrid-Inverter.pdf" },
                    ],
                    note: "LiFePO4 lithium home UPS batteries · Solar compatible · INTU PRO also available in 25.6V / 100Ah for all 24V systems",
                },
                "solar-panels": {
                    models: [
                        { name: "Smarten Polycrystalline Panels", note: "40W – 545W · 12V/24V" },
                        { name: "Smarten Monocrystalline Panels", note: "225W – 545W" },
                        { name: "Bifacial · DCR & Non-DCR", note: "Built for extreme heat, dust and heavy rain" },
                    ],
                    note: "Call for details and current pricing.",
                },
                "complete-solar-setup": {
                    points: ["Complete solar panel setup", "Smarten MPPT/PWM charge controllers and solar DC wire available", "Professional installation assistance"],
                    note: "Call for details and current pricing.",
                },
                "cctv-cameras": {
                    points: ["All types of CCTV cameras", "For homes, shops, offices and other properties", "Installation-related services available"],
                    note: "Tell us your property type — we will suggest suitable options.",
                },
                "broadband-connection": {
                    points: ["Home broadband", "Business broadband", "Reliable connectivity solutions"],
                    note: "Call to check availability in your area.",
                },
                "ev-chargers": {
                    models: [
                        { name: "Smarten EV Scooter Charger", tag: "5 Stage FLC Charging Technology", features: ["72V/10A · 72V/3.3A · 60V/4A · 48V/5A", "Lithium & Lead Acid Compatible", "Reliable Charging", "Compact Size", "12 Months Warranty"] },
                        { name: "Smarten Ryder Lithium EV Battery (SRD10536)", tag: "51.2V 100Ah · 5.12kWh", features: ["Remote & App-based Monitoring", "Fast Charging", "Long Distance", "Easy Connection", "Durable Design", "4000+ Cycle Life", "AIS 156 Complied"] },
                        { name: "Smarten Lithium EV Rickshaw Charger", note: "51.2V / 30A" },
                        { name: "Cykal E-Bikes", note: "Desire · Passion · Passion Bold — 250W BLDC motor, 7.5Ah removable battery" },
                    ],
                    note: "From the Smarten 2021–22 catalogue. Call for availability and pricing.",
                },
            },
        },
        brands: {
            eyebrow: "In Stock",
            headingA: "BRANDS WE ",
            headingB: "CARRY",
            sub: "Genuine products from trusted names — Smarten, INTU, Exide, Amaron and more.",
            chips: [
                { name: "Smarten", note: "Authorised Distributor" },
                { name: "INTU", note: "Lithium Home UPS Batteries" },
                { name: "Exide", note: "Batteries" },
                { name: "Amaron", note: "Batteries" },
            ],
        },
        solar: {
            eyebrow: "01 — Solar Energy",
            headingA: "SWITCH TO ",
            headingB: "SMARTER ENERGY",
            sub: "Explore solar panel and complete solar setup solutions for a smarter approach to energy — for your home or your business.",
            chips: ["Solar Panels", "Solar Power", "Energy Storage", "Home Solutions"],
            cta: "Get Solar Information",
            frameLeft: "Solar Array",
            frameRight: "Energy Flow Active",
        },
        power: {
            eyebrow: "02 — Power Backup",
            headingA: "STAY POWERED. ",
            headingB: "STAY PREPARED.",
            sub: "Choose reliable power backup solutions for your home or business.",
            flow: ["ELECTRICITY", "INVERTER", "BATTERY", "HOME"],
        },
        security: {
            eyebrow: "03 — CCTV Security",
            headingA: "SECURITY YOU ",
            headingB: "CAN SEE",
            sub: "Protect your home, shop or business with modern CCTV camera solutions — supply and installation-related services included.",
            cats: ["Home Security", "Shop Security", "Office Security", "CCTV Installation"],
            cta: "Ask About CCTV",
            cam: "CAM-01 · LIVE",
            scanning: "Scanning",
        },
        broadband: {
            eyebrow: "04 — Connectivity",
            headingA: "CONNECT ",
            headingB: "WITHOUT LIMITS",
            sub: "Stay connected with broadband solutions for your home or business — home broadband and business broadband, set up for the way you work and live.",
            chips: ["Home Broadband", "Business Broadband"],
            cta: "Get Broadband Connection",
            frameLeft: "Network Core",
            frameRight: "Nodes Connected",
        },
        services: {
            eyebrow: "What We Do",
            heading: "OUR SERVICES",
            items: [
                { title: "Power Backup Solutions", description: "Inverter, battery and lithium battery solutions." },
                { title: "Solar Solutions", description: "Solar panel and complete solar setup solutions." },
                { title: "CCTV Solutions", description: "CCTV camera supply and installation-related services." },
                { title: "Broadband Services", description: "Broadband connectivity solutions." },
                { title: "Installation & Support", description: "Professional assistance for relevant products and setups." },
            ],
        },
        why: {
            eyebrow: "About Us",
            headingA: "WHY CHOOSE ",
            headingB: "FARAKKA BROADBAND?",
            sub: "A local business in Paikpara, Beniagram serving Murshidabad with power backup, solar, CCTV and broadband solutions for homes and businesses.",
            cards: ["Reliable Solutions", "Power Backup Expertise", "Solar Solutions", "Security Solutions", "Connectivity Solutions", "Customer Focused"],
        },
        process: {
            eyebrow: "The Process",
            heading: "HOW IT WORKS",
            steps: [
                { num: "01", title: "Contact Us", description: "Call 9933719744 or send an enquiry." },
                { num: "02", title: "Discuss Your Requirement", description: "Tell us what product or solution you need." },
                { num: "03", title: "Get the Right Solution", description: "Receive suitable product/service information." },
                { num: "04", title: "Get Started", description: "Proceed with the selected solution." },
            ],
        },
        faq: {
            eyebrow: "Common Questions",
            headingA: "FREQUENTLY ASKED ",
            headingB: "QUESTIONS",
            items: [
                { q: "What products and services do you offer?", a: "We offer Smarten inverters, inverter batteries, lithium batteries, solar panels and complete solar setups, all types of CCTV cameras with installation, and broadband connections for homes and businesses — along with installation and support assistance." },
                { q: "How much does a product or setup cost?", a: "Pricing depends on the model, capacity and your exact requirement. Call us on 9933719744 or send an enquiry with what you need, and we will share the current price and suitable options." },
                { q: "Do you provide installation?", a: "Yes. We provide professional assistance for relevant products and setups — including CCTV installation and complete solar panel setup. Tell us your requirement and we will guide you." },
                { q: "Which areas do you serve?", a: "We are located at Paikpara, Beniagram in Murshidabad, West Bengal, with another shop at NH 34, New Farakka (opposite Indian Oil Petrol, Ghusia Pump). Call us to check availability for your area." },
                { q: "Do you serve both homes and businesses?", a: "Yes. We provide home and commercial power backup, home and business CCTV surveillance, and home and business broadband solutions." },
                { q: "Which brands do you carry?", a: "We are an authorised distributor for Smarten and also carry INTU lithium batteries, Exide and Amaron batteries, and more. Contact us for the current range in stock." },
            ],
        },
        cta: {
            heading: "LOOKING FOR THE RIGHT POWER, SOLAR, SECURITY OR BROADBAND SOLUTION?",
            sub: "Talk to Farakka Broadband today.",
            call: "CALL",
            enquiry: "Send an Enquiry",
        },
        contact: {
            eyebrow: "Contact",
            heading: "GET IN TOUCH",
            phoneLabel: "Phone",
            alsoCall: "Also call:",
            addressLabel: "Address",
            addr1Title: "Paikpara (Main)",
            addr2Title: "New Farakka (Branch)",
            formTitle: "Send an Enquiry",
            formSub: "Tell us what you need — we will get back to you.",
            name: "Full Name",
            namePh: "Your name",
            phone: "Phone Number",
            phonePh: "Your phone number",
            service: "Select Product/Service",
            servicePh: "Choose a product or service",
            message: "Message",
            messagePh: "Tell us what you need...",
            submit: "Submit Enquiry",
            sending: "Sending...",
            success: "Your enquiry has been received. For anything urgent, call 9933719744.",
            errors: {
                name: "Please enter your full name.",
                phone: "Please enter a valid phone number.",
                service: "Please select a product or service.",
                message: "Please write a short message.",
            },
            toastOk: "Enquiry received. Farakka Broadband will get back to you soon.",
            toastErr: "Could not send your enquiry. Please call 9933719744 instead.",
            map1: "Farakka Broadband — Paikpara, Beniagram, Murshidabad, West Bengal 742212",
            map2: "Farakka Broadband — NH 34, New Farakka, opposite Indian Oil Petrol (Ghusia Pump)",
        },
        footer: {
            description: "Power backup, solar, CCTV and broadband solutions for homes and businesses.",
            links: "Links",
            products: "Products",
            productLinks: ["Inverter", "Battery", "Lithium Battery", "Solar", "CCTV", "Broadband"],
            contact: "Contact",
            copyright: "© 2026 Farakka Broadband. All Rights Reserved.",
        },
        mobileBar: { call: "Call Now", enquire: "Enquire" },
    },
    bn: {
        nav: {
            home: "হোম", about: "আমাদের সম্পর্কে", products: "পণ্য", services: "পরিষেবা",
            solar: "সোলার", cctv: "সিসিটিভি", contact: "যোগাযোগ", call: "কল করুন",
        },
        hero: {
            eyebrow: "পাওয়ার · সোলার · সিকিউরিটি · কানেক্টিভিটি — মুর্শিদাবাদ",
            lines: [
                { text: "আপনার ঘরে ", accent: "শক্তি।" },
                { text: "আপনার জগতের ", accent: "সুরক্ষা।" },
                { text: "আপনার জীবনের ", accent: "সংযোগ।" },
            ],
            sub: "ফারাক্কা ব্রডব্যান্ড থেকে পাওয়ার ব্যাকআপ, সৌর শক্তি, সিসিটিভি সিকিউরিটি এবং ব্রডব্যান্ড কানেক্টিভিটির সম্পূর্ণ সমাধান।",
            call: "কল করুন",
            explore: "পণ্য দেখুন",
            chips: ["পাওয়ার ব্যাকআপ", "সোলার সমাধান", "সিসিটিভি সিকিউরিটি", "ব্রডব্যান্ড সংযোগ"],
        },
        marquee: ["পাওয়ার ব্যাকআপ", "সৌর শক্তি", "সিসিটিভি সিকিউরিটি", "ব্রডব্যান্ড", "ইনস্টলেশন ও সাপোর্ট", "হোম ও ব্যবসা"],
        products: {
            eyebrow: "ক্যাটালগ",
            heading: "আমাদের পণ্য",
            sub: "পাওয়ার, এনার্জি, সিকিউরিটি ও কানেক্টিভিটির স্মার্ট সমাধান।",
            items: {
                "smarten-inverter": { name: "Smarten Inverter", description: "ঘর ও অফিসে নির্ভরযোগ্য পাওয়ার ব্যাকআপের জন্য ভরসাযোগ্য ইনভার্টার সমাধান।", cta: "জিজ্ঞাসা করুন", category: "পাওয়ার ব্যাকআপ" },
                "inverter-battery": { name: "Inverter Battery", description: "প্রতিদিনের নির্ভরযোগ্য ব্যবহারের জন্য পাওয়ার ব্যাকআপ ব্যাটারি সমাধান।", cta: "জিজ্ঞাসা করুন", category: "পাওয়ার ব্যাকআপ" },
                "lithium-battery": { name: "Lithium Battery", description: "দক্ষ ও নির্ভরযোগ্য এনার্জি স্টোরেজের জন্য আধুনিক ব্যাটারি প্রযুক্তি।", cta: "জিজ্ঞাসা করুন", category: "পাওয়ার ব্যাকআপ" },
                "solar-panels": { name: "Solar Panels", description: "আধুনিক সোলার প্যানেল সমাধানের মাধ্যমে সৌর শক্তির সদ্ব্যবহার করুন।", cta: "সোলার কোট নিন", category: "সোলার" },
                "complete-solar-setup": { name: "Complete Solar Setup", description: "প্যানেল সেটআপ ও প্রয়োজনীয় ইনস্টলেশনসহ সম্পূর্ণ সোলার সমাধান।", cta: "সোলার কোট নিন", category: "সোলার" },
                "cctv-cameras": { name: "CCTV Cameras", description: "ঘর, দোকান, অফিস ও অন্যান্য সম্পত্তির জন্য সিকিউরিটি ক্যামেরা সমাধান।", cta: "জিজ্ঞাসা করুন", category: "সিকিউরিটি" },
                "broadband-connection": { name: "Broadband Connection", description: "ঘর ও ব্যবসার জন্য নির্ভরযোগ্য ব্রডব্যান্ড কানেক্টিভিটি সমাধান।", cta: "সংযোগ নিন", category: "কানেক্টিভিটি" },
                "ev-chargers": { name: "EV Chargers & E-Bikes", description: "স্কুটার, রিকশা ও সাইকেলের জন্য Smarten EV চার্জার, লিথিয়াম EV ব্যাটারি ও Cykal ইলেকট্রিক বাইক।", cta: "জিজ্ঞাসা করুন", category: "ইভি চার্জিং" },
            },
            viewDetails: "বিস্তারিত দেখুন",
            downloadCatalogue: "Smarten ক্যাটালগ ডাউনলোড করুন (PDF)",
            modal: { call: "কল করুন", enquire: "এটি নিয়ে জিজ্ঞাসা করুন" },
            details: {
                "smarten-inverter": {
                    groups: [
                        { title: "হোম UPS — পিওর সাইন ওয়েভ", items: [
                            { name: "Bravo", note: "1050VA – 10000VA · 12V–120V" },
                            { name: "Bravo Eco", note: "875VA – 2050VA · ৩০% পর্যন্ত বিদ্যুৎ সাশ্রয়" },
                            { name: "Nova", note: "1075VA – 3050VA · স্টাইলের সঙ্গে পারফরম্যান্স" },
                        ]},
                        { title: "সোলার PCU", items: [
                            { name: "Helio", note: "MPPT · বিল্ট-ইন লিথিয়াম ব্যাটারি · 900–1500VA" },
                            { name: "Trendy / Superb", note: "MPPT · 1100VA – 20KVA" },
                            { name: "Boom", note: "সাশ্রয়ী PWM সোলার PCU · 400–2050VA" },
                            { name: "Kranti+", note: "ব্যাটারি-বিহীন সোলার PCU · 5–10KVA" },
                            { name: "Ultra", note: "MPPT হাইব্রিড সোলার PCU · 1–50KVA" },
                        ]},
                        { title: "অন-গ্রিড সোলার ইনভার্টার", items: [
                            { name: "Star (সিঙ্গেল ফেজ)", note: "1KW – 6KW · সর্বোচ্চ 97.8% দক্ষতা" },
                            { name: "Star (থ্রি ফেজ)", note: "5KW – 25KW · IP66" },
                        ]},
                        { title: "সোলার চার্জ কন্ট্রোলার", items: [
                            { name: "Prime+", note: "MPPT · আপনার ইনভার্টারকে সোলার ইনভার্টারে বদলে দেয়" },
                            { name: "Savior", note: "PWM · 25A পর্যন্ত PV কারেন্ট" },
                        ]},
                    ],
                    note: "Smarten-এর অথরাইজড ডিস্ট্রিবিউটর — Smarten ২০২১–২২ ক্যাটালগের সম্পূর্ণ রেঞ্জ। বর্তমান মডেল ও দামের জন্য কল করুন।",
                },
                "inverter-battery": {
                    models: [
                        { name: "Smarten Boom — টিউবুলার ও টল টিউবুলার", tag: "Worry not, let's boom!", features: ["40Ah – 180Ah · 12V", "কম সেলফ ডিসচার্জ", "সুপিরিয়ার হাই রেট ডিসচার্জ", "লং সাইকেল লাইফ", "সহজ রক্ষণাবেক্ষণের লেভেল ইন্ডিকেটর"] },
                        { name: "Smarten Shine+ / Saver+ — সোলার টল টিউবুলার", tag: "Durable & compatible in all ways!", features: ["170Ah – 350Ah · 12V", "হাই-পাওয়ার সেলেনিয়াম প্রযুক্তি", "বেশি ব্যাকআপ, বেশি নির্ভরযোগ্যতা", "আল্ট্রা লো মেইনটেন্যান্স", "দীর্ঘ লাইফ"] },
                        { name: "Smarten Star Series ST 200C10", note: "টল টিউবুলার ব্যাটারি" },
                        { name: "Exide ব্যাটারি", note: "ঘর ও গাড়ির জন্য" },
                        { name: "Amaron ব্যাটারি", note: "বাইক ও চার চাকর গাড়ির ব্যাটারি পাওয়া যায়" },
                    ],
                    note: "আপনার ঘর বা দোকানের জন্য সঠিক ক্ষমতার ব্যাটারি জানতে জিজ্ঞাসা করুন।",
                },
                "lithium-battery": {
                    models: [
                        { name: "INTU", tag: "12.8V 60Ah · 768Wh", features: ["LiFePO4", "সব ইনভার্টারের সাথে কম্প্যাটিবল", "৫ বছরের ওয়ারেন্টি"] },
                        { name: "INTU+ (HA550)", tag: "12.8V 90Ah · 1152Wh", features: ["LiFePO4", "কমপ্যাক্ট ও হালকা", "দ্রুত চার্জিং", "৫ বছরের ওয়ারেন্টি"] },
                        { name: "INTU X", tag: "12.8V 100Ah · 1280Wh", features: ["বেশি ক্ষমতা", "বর্ধিত ব্যাকআপ", "মিক্সার কম্প্যাটিবল", "৫ বছরের ওয়ারেন্টি"] },
                        { name: "INTU PRO", tag: "12.8V 150Ah · 25.6V 100Ah · 2560Wh পর্যন্ত", features: ["সর্বোচ্চ পারফরম্যান্স", "ভারী লোড সাপোর্ট", "১০ বছরের সার্ভিস লাইফ"] },
                        { name: "INTU HOME PSW 1100", tag: "ইনবিল্ট লিথিয়াম ইনভার্টার · 1100VA / 880W", features: ["ইনবিল্ট 12.8V 100Ah লিথিয়াম (1280Wh)", "পিওর সাইন ওয়েভ", "20A দ্রুত চার্জিং", "ওয়াল মাউন্টেবল", "LCD ডিসপ্লে", "৫ বছরের ওয়ারেন্টি"] },
                        { name: "INTU ZON4", tag: "সোলার হাইব্রিড ইনভার্টার · 4000W", features: ["6500W পর্যন্ত MPPT সোলার চার্জিং", "ব্যাটারি ছাড়া বা সহ চলে", "বিল্ট-ইন BMS + WiFi মনিটরিং", "পিওর সাইন ওয়েভ", "স্লিম বডি"] },
                        { name: "Smarten ENERGia", tag: "Power with Intelligence", features: ["12.8V / 25.6V / 51.2V — 100Ah", "ব্লুটুথ কানেক্টিভিটি*", "দীর্ঘায়িত লাইফস্প্যান", "কম সেলফ ডিসচার্জ", "লং লাইফ সাইকেল", "অ্যাক্টিভ ব্যালেন্সিং*", "পরিবেশ-বান্ধব"] },
                    ],
                    brochures: [
                        { label: "INTU / INTU+ / INTU X / INTU PRO রেঞ্জ ব্রোশার (PDF)", file: "/docs/INTU-PLUS-Brochure.pdf" },
                        { label: "INTU HOME PSW 1100 ব্রোশার (PDF)", file: "/docs/INTU-HOME-PSW-1100-Brochure.pdf" },
                        { label: "INTU ZON4 হাইব্রিড ইনভার্টার ব্রোশার (PDF)", file: "/docs/INTU-ZON4-Hybrid-Inverter.pdf" },
                    ],
                    note: "LiFePO4 লিথিয়াম হোম UPS ব্যাটারি · সোলার কম্প্যাটিবল · INTU PRO সব 24V সিস্টেমের জন্য 25.6V / 100Ah-এও পাওয়া যায়",
                },
                "solar-panels": {
                    models: [
                        { name: "Smarten পলিক্রিস্টালাইন প্যানেল", note: "40W – 545W · 12V/24V" },
                        { name: "Smarten মনোক্রিস্টালাইন প্যানেল", note: "225W – 545W" },
                        { name: "বাইফেশিয়াল · DCR ও Non-DCR", note: "প্রবল গরম, ধুলো ও ভারী বৃষ্টির জন্য তৈরি" },
                    ],
                    note: "বিস্তারিত ও বর্তমান দামের জন্য কল করুন।",
                },
                "complete-solar-setup": {
                    points: ["সম্পূর্ণ সোলার প্যানেল সেটআপ", "Smarten MPPT/PWM চার্জ কন্ট্রোলার ও সোলার DC ওয়্যার পাওয়া যায়", "পেশাদার ইনস্টলেশন সহায়তা"],
                    note: "বিস্তারিত ও বর্তমান দামের জন্য কল করুন।",
                },
                "cctv-cameras": {
                    points: ["সব ধরনের সিসিটিভি ক্যামেরা", "ঘর, দোকান, অফিস ও অন্যান্য সম্পত্তির জন্য", "ইনস্টলেশন-সংক্রান্ত পরিষেবা পাওয়া যায়"],
                    note: "আপনার প্রয়োজন জানালে উপযুক্ত বিকল্প বলে দেব।",
                },
                "broadband-connection": {
                    points: ["হোম ব্রডব্যান্ড", "বিজনেস ব্রডব্যান্ড", "নির্ভরযোগ্য কানেক্টিভিটি সমাধান"],
                    note: "আপনার এলাকায় পাওয়া যাবে কিনা জানতে কল করুন।",
                },
                "ev-chargers": {
                    models: [
                        { name: "Smarten EV স্কুটার চার্জার", tag: "5 Stage FLC Charging Technology", features: ["72V/10A · 72V/3.3A · 60V/4A · 48V/5A", "লিথিয়াম ও লেড অ্যাসিড কম্প্যাটিবল", "নির্ভরযোগ্য চার্জিং", "কমপ্যাক্ট সাইজ", "১২ মাসের ওয়ারেন্টি"] },
                        { name: "Smarten Ryder লিথিয়াম EV ব্যাটারি (SRD10536)", tag: "51.2V 100Ah · 5.12kWh", features: ["রিমোট ও অ্যাপ-ভিত্তিক মনিটরিং", "ফাস্ট চার্জিং", "দীর্ঘ দূরত্ব", "সহজ সংযোগ", "টেকসই ডিজাইন", "৪০০০+ সাইকেল লাইফ", "AIS 156 কমপ্লায়েড"] },
                        { name: "Smarten লিথিয়াম EV রিকশা চার্জার", note: "51.2V / 30A" },
                        { name: "Cykal ই-বাইক", note: "Desire · Passion · Passion Bold — 250W BLDC মোটর, 7.5Ah রিমুভেবল ব্যাটারি" },
                    ],
                    note: "Smarten ২০২১–২২ ক্যাটালগ থেকে। পাওয়া যায় কিনা ও দামের জন্য কল করুন।",
                },
            },
        },
        brands: {
            eyebrow: "স্টকে আছে",
            headingA: "আমাদের ",
            headingB: "ব্র্যান্ডসমূহ",
            sub: "বিশ্বস্ত নামের জেনুইন পণ্য — Smarten, INTU, Exide, Amaron এবং আরও অনেক।",
            chips: [
                { name: "Smarten", note: "অথরাইজড ডিস্ট্রিবিউটর" },
                { name: "INTU", note: "লিথিয়াম হোম UPS ব্যাটারি" },
                { name: "Exide", note: "ব্যাটারি" },
                { name: "Amaron", note: "ব্যাটারি" },
            ],
        },
        solar: {
            eyebrow: "০১ — সৌর শক্তি",
            headingA: "বদলে যান ",
            headingB: "স্মার্ট এনার্জিতে",
            sub: "আপনার ঘর বা ব্যবসার জন্য আরও স্মার্ট শক্তির পথে — সোলার প্যানেল ও সম্পূর্ণ সোলার সেটআপ সমাধান দেখুন।",
            chips: ["সোলার প্যানেল", "সোলার পাওয়ার", "এনার্জি স্টোরেজ", "হোম সলিউশন"],
            cta: "সোলার তথ্য নিন",
            frameLeft: "সোলার অ্যারে",
            frameRight: "এনার্জি ফ্লো চালু",
        },
        power: {
            eyebrow: "০২ — পাওয়ার ব্যাকআপ",
            headingA: "চালু থাকুন। ",
            headingB: "প্রস্তুত থাকুন।",
            sub: "আপনার ঘর বা ব্যবসার জন্য নির্ভরযোগ্য পাওয়ার ব্যাকআপ সমাধান বেছে নিন।",
            flow: ["বিদ্যুৎ", "ইনভার্টার", "ব্যাটারি", "আপনার ঘর"],
        },
        security: {
            eyebrow: "০৩ — সিসিটিভি সিকিউরিটি",
            headingA: "সুরক্ষা, যা ",
            headingB: "দেখা যায়",
            sub: "আধুনিক সিসিটিভি ক্যামেরা সমাধানে আপনার ঘর, দোকান বা ব্যবসাকে রাখুন সুরক্ষিত — সাপ্লাই ও ইনস্টলেশন-সংক্রান্ত পরিষেবাসহ।",
            cats: ["হোম সিকিউরিটি", "দোকান সিকিউরিটি", "অফিস সিকিউরিটি", "সিসিটিভি ইনস্টলেশন"],
            cta: "সিসিটিভি সম্পর্কে জানুন",
            cam: "CAM-01 · লাইভ",
            scanning: "স্ক্যানিং",
        },
        broadband: {
            eyebrow: "০৪ — কানেক্টিভিটি",
            headingA: "সংযোগ ",
            headingB: "সীমাহীন",
            sub: "আপনার ঘর বা ব্যবসার জন্য ব্রডব্যান্ড সমাধানে সবসময় সংযুক্ত থাকুন — আপনার কাজ ও জীবনধারার সঙ্গে মানিয়ে হোম ও বিজনেস ব্রডব্যান্ড।",
            chips: ["হোম ব্রডব্যান্ড", "বিজনেস ব্রডব্যান্ড"],
            cta: "ব্রডব্যান্ড সংযোগ নিন",
            frameLeft: "নেটওয়ার্ক কোর",
            frameRight: "নোড সংযুক্ত",
        },
        services: {
            eyebrow: "আমরা যা করি",
            heading: "আমাদের পরিষেবাসমূহ",
            items: [
                { title: "পাওয়ার ব্যাকআপ সমাধান", description: "ইনভার্টার, ব্যাটারি ও লিথিয়াম ব্যাটারি সমাধান।" },
                { title: "সোলার সমাধান", description: "সোলার প্যানেল ও সম্পূর্ণ সোলার সেটআপ সমাধান।" },
                { title: "সিসিটিভি সমাধান", description: "সিসিটিভি ক্যামেরা সাপ্লাই ও ইনস্টলেশন-সংক্রান্ত পরিষেবা।" },
                { title: "ব্রডব্যান্ড পরিষেবা", description: "ব্রডব্যান্ড কানেক্টিভিটি সমাধান।" },
                { title: "ইনস্টলেশন ও সাপোর্ট", description: "সংশ্লিষ্ট পণ্য ও সেটআপের জন্য পেশাদার সহায়তা।" },
            ],
        },
        why: {
            eyebrow: "আমাদের সম্পর্কে",
            headingA: "কেন ",
            headingB: "ফারাক্কা ব্রডব্যান্ড?",
            sub: "মুর্শিদাবাদের পাইকপাড়া, বেনিয়াগ্রামের একটি স্থানীয় ব্যবসা — ঘর ও ব্যবসার জন্য পাওয়ার ব্যাকআপ, সোলার, সিসিটিভি এবং ব্রডব্যান্ড সমাধান।",
            cards: ["নির্ভরযোগ্য সমাধান", "পাওয়ার ব্যাকআপ দক্ষতা", "সোলার সমাধান", "সিকিউরিটি সমাধান", "কানেক্টিভিটি সমাধান", "গ্রাহক-কেন্দ্রিক"],
        },
        process: {
            eyebrow: "প্রক্রিয়া",
            heading: "কীভাবে কাজ করে",
            steps: [
                { num: "০১", title: "যোগাযোগ করুন", description: "9933719744 নম্বরে কল করুন অথবা অনুসন্ধান পাঠান।" },
                { num: "০২", title: "আপনার প্রয়োজন জানান", description: "আপনার কোন পণ্য বা সমাধান দরকার তা জানান।" },
                { num: "০৩", title: "সঠিক সমাধান পান", description: "উপযুক্ত পণ্য/পরিষেবার তথ্য পান।" },
                { num: "০৪", title: "শুরু করুন", description: "নির্বাচিত সমাধান নিয়ে এগিয়ে যান।" },
            ],
        },
        faq: {
            eyebrow: "সাধারণ প্রশ্ন",
            headingA: "সচরাচর জিজ্ঞাসিত ",
            headingB: "প্রশ্ন",
            items: [
                { q: "আপনারা কী কী পণ্য ও পরিষেবা দেন?", a: "আমরা Smarten ইনভার্টার, ইনভার্টার ব্যাটারি, লিথিয়াম ব্যাটারি, সোলার প্যানেল ও সম্পূর্ণ সোলার সেটআপ, সব ধরনের সিসিটিভি ক্যামেরা ও ইনস্টলেশন এবং ঘর ও ব্যবসার জন্য ব্রডব্যান্ড সংযোগ দিয়ে থাকি — ইনস্টলেশন ও সাপোর্ট সহায়তাসহ।" },
                { q: "পণ্য বা সেটআপের দাম কত?", a: "দাম নির্ভর করে মডেল, ক্ষমতা ও আপনার প্রয়োজনের ওপর। 9933719744 নম্বরে কল করুন বা অনুসন্ধান পাঠান — আমরা বর্তমান দাম ও উপযুক্ত বিকল্প জানিয়ে দেব।" },
                { q: "আপনারা কি ইনস্টলেশন করে দেন?", a: "হ্যাঁ। সংশ্লিষ্ট পণ্য ও সেটআপের জন্য পেশাদার সহায়তা দিই — সিসিটিভি ইনস্টলেশন ও সম্পূর্ণ সোলার প্যানেল সেটআপসহ। আপনার প্রয়োজন জানালেই আমরা পথ দেখিয়ে দেব।" },
                { q: "কোন কোন এলাকায় পরিষেবা দেন?", a: "আমরা মুর্শিদাবাদের পাইকপাড়া, বেনিয়াগ্রামে অবস্থিত, সঙ্গে NH 34, নিউ ফারাক্কায় (ইন্ডিয়ান অয়েল পেট্রোল পাম্প, ঘুসিয়ার উল্টোদিকে) আরেকটি দোকান আছে। আপনার এলাকায় পরিষেবা পাওয়া যাবে কিনা জানতে কল করুন।" },
                { q: "ঘর ও ব্যবসা — দুইটির জন্যই কি?", a: "হ্যাঁ। হোম ও কমার্শিয়াল পাওয়ার ব্যাকআপ, হোম ও বিজনেস সিসিটিভি সারভেইল্যান্স এবং হোম ও বিজনেস ব্রডব্যান্ড সমাধান দিই।" },
                { q: "কোন কোন ব্র্যান্ড পাবেন?", a: "আমরা Smarten-এর অথরাইজড ডিস্ট্রিবিউটর, এছাড়া INTU লিথিয়াম ব্যাটারি, Exide ও Amaron ব্যাটারিসহ আরও অনেক ব্র্যান্ড রাখি। স্টকে এখন কী আছে জানতে যোগাযোগ করুন।" },
            ],
        },
        cta: {
            heading: "পাওয়ার, সোলার, সিকিউরিটি বা ব্রডব্যান্ড — সঠিক সমাধান খুঁজছেন?",
            sub: "আজই ফারাক্কা ব্রডব্যান্ডের সঙ্গে কথা বলুন।",
            call: "কল করুন",
            enquiry: "অনুসন্ধান পাঠান",
        },
        contact: {
            eyebrow: "যোগাযোগ",
            heading: "যোগাযোগ করুন",
            phoneLabel: "ফোন",
            alsoCall: "আরও কল করুন:",
            addressLabel: "ঠিকানা",
            addr1Title: "পাইকপাড়া (প্রধান)",
            addr2Title: "নিউ ফারাক্কা (শাখা)",
            formTitle: "অনুসন্ধান পাঠান",
            formSub: "আপনার কী প্রয়োজন জানান — আমরা যোগাযোগ করব।",
            name: "পুরো নাম",
            namePh: "আপনার নাম",
            phone: "ফোন নম্বর",
            phonePh: "আপনার ফোন নম্বর",
            service: "পণ্য/পরিষেবা নির্বাচন করুন",
            servicePh: "একটি পণ্য বা পরিষেবা বেছে নিন",
            message: "বার্তা",
            messagePh: "আপনার কী প্রয়োজন লিখুন...",
            submit: "অনুসন্ধান জমা দিন",
            sending: "পাঠানো হচ্ছে...",
            success: "আপনার অনুসন্ধান পৌঁছেছে। জরুরি প্রয়োজনে 9933719744 নম্বরে কল করুন।",
            errors: {
                name: "আপনার পুরো নাম লিখুন।",
                phone: "সঠিক ফোন নম্বর লিখুন।",
                service: "একটি পণ্য বা পরিষেবা নির্বাচন করুন।",
                message: "একটি ছোট বার্তা লিখুন।",
            },
            toastOk: "অনুসন্ধান পৌঁছেছে। ফারাক্কা ব্রডব্যান্ড শীঘ্রই যোগাযোগ করবে।",
            toastErr: "অনুসন্ধান পাঠানো যায়নি। অনুগ্রহ করে 9933719744 নম্বরে কল করুন।",
            map1: "ফারাক্কা ব্রডব্যান্ড — পাইকপাড়া, বেনিয়াগ্রাম, মুর্শিদাবাদ ৭৪২২১২",
            map2: "ফারাক্কা ব্রডব্যান্ড — NH 34, নিউ ফারাক্কা, ইন্ডিয়ান অয়েল পেট্রোল পাম্পের উল্টোদিকে (ঘুসিয়া)",
        },
        footer: {
            description: "ঘর ও ব্যবসার জন্য পাওয়ার ব্যাকআপ, সোলার, সিসিটিভি ও ব্রডব্যান্ড সমাধান।",
            links: "লিংক",
            products: "পণ্য",
            productLinks: ["ইনভার্টার", "ব্যাটারি", "লিথিয়াম ব্যাটারি", "সোলার", "সিসিটিভি", "ব্রডব্যান্ড"],
            contact: "যোগাযোগ",
            copyright: "© ২০২৬ ফারাক্কা ব্রডব্যান্ড। সর্বস্বত্ব সংরক্ষিত।",
        },
        mobileBar: { call: "কল করুন", enquire: "জিজ্ঞাসা করুন" },
    },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("fb-lang") || "en";
        } catch {
            return "en";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem("fb-lang", lang);
        } catch { /* private mode */ }
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang, t: STR[lang] }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() {
    return useContext(LangContext);
}
